import { useState } from 'react';
import { MessageType } from 'types/chat.types';
import { ChakraConfirmationDialog } from 'app/components/Dialogs';
import { useAppDispatch } from 'app/store';
import { deleteChatMessageEffect } from 'app/store/Chat/effects';
import { removeFromMessages } from 'app/store/Chat/slice';

interface MessageDeleteDialogProps {
  message?: MessageType;
  onClose: () => void;
}

export const MessageDeleteDialog = ({
  message,
  onClose,
}: MessageDeleteDialogProps) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const handleMessageDelete = async (message: MessageType) => {
    if (message.guid.startsWith('RETRY')) {
      dispatch(removeFromMessages(message.guid));
    } else {
      await dispatch(deleteChatMessageEffect(message));
    }
  };

  const onSubmit = async () => {
    if (!message) {
      return;
    }
    setLoading(true);
    try {
      await handleMessageDelete(message);
      onClose();
    } catch (e) {
      // proceed
    } finally {
      setLoading(false);
    }
  };

  return (
    <ChakraConfirmationDialog
      isOpen={Boolean(message)}
      title="Delete Message"
      message="Are you sure you want to delete message?"
      actionButtonText="Delete"
      handleAction={onSubmit}
      disableActions={loading}
      handleClose={onClose}
    />
  );
};
